import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Suaje, Pegue, SuajeService } from '../../services/suaje.service';
import { ActivatedRoute } from '@angular/router';
import { PdfTemplates } from '../../pdfTemplates';

@Component({
  selector: 'app-display-suaje',
  templateUrl: './display-suaje.component.html',
  styleUrls: ['./display-suaje.component.css']
})

export class DisplaySuajeComponent implements OnInit {

  clabeError: boolean;

  suajeForm: FormGroup;
  suaje: any;
  id: string = '';
  pegue: Pegue = {
    FA: false,
    lineal: false,
    esquinas4: false,
    NA : false,
  };

  constructor(
    private service: SuajeService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    let suajeSub = this.service.getSuaje(this.id).subscribe(([{pegue, ...suaje}]) => {
      suajeSub.unsubscribe();
      this.pegue = pegue;
      this.suaje = suaje;
      suaje.customerName = suaje.customerObj.name;
      this.suajeForm.patchValue(suaje);
    })

  }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.suajeForm = this.fb.group({
      code: ['', Validators.required],
      long: ['', Validators.required],
      wide: ['', Validators.required],
      height: ['', Validators.required],
      horizontal: ['', Validators.required],
      vertical: ['', Validators.required],
      rows: ['', Validators.required],
      columns: ['', Validators.required],
      other: '',
      notes: '',

      customerName: ''
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    let suaje = {
      pegue: this.pegue,
      ...value
    }
    this.service.updateSuaje(this.id, suaje);
    this.service.windowReplace('read');
  }

  get dataPhp(){
    return JSON.stringify(this.suajeForm);
  }

  onPfdExport(){

    let rows = {}
    let headers = {}

      PdfTemplates.Reports.DisplaySuajeRequest(rows, headers)











  }


}
